<template>
  <AppSection id="vendor-dashboar" :title="$getConst.pages.vendor.vendor_dashboard" type="page">
    <AppSection
      id="question-form-page"
      :title="$getConst.pages.vendor.vendor_dashboard_page_title"
      type="section"
      select-language
    >

      <b-row class="justify-content-center py-5">

        <template v-for="option in options">
          <b-col xl="3" lg="4" md="4" sm="6" class="pb-4">
            <AppPageOptionBox
              @onClick="onSelectOption(option)" :text="option.text" :icon="option.icon"/>
          </b-col>
        </template>

      </b-row>

    </AppSection>
  </AppSection>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import AppPageOptionBox from "../../../components/common/utils/AppPageOptionBox";

  export default {
    name: "index",
    components: {AppPageOptionBox, AppSection},
    computed: {
      options() {
        return [
          {
            destination: "TIMESHEETS",
            text: this.$t(this.$getConst.pages.vendor.vendor_timesheets),
            icon:this.$getConst.svgIcons.timesheets
          },
          {
            destination: "INVOICES",
            text: this.$t(this.$getConst.pages.vendor.vendor_invoices),
            icon:this.$getConst.svgIcons.invoices
          },
        ];
      }
    },
    methods: {
      onSelectOption(option) {
        switch (option.destination) {
          case "TIMESHEETS":
            this.$router.push({name: this.$getConst.routesNames.vendortimesheets});
            break;
          case "INVOICES":
            this.$router.push({name: this.$getConst.routesNames.invoices});
            break;
          default:
            break;
        }
      }
    },
  }
</script>

